export default __webpack_public_path__ + "static/media/logo.2dc4235d.png";